<template>
  <v-container>
    <h2>
      What is your phone number?
    </h2>

    <v-form ref="form" @submit.prevent="onContinue">
      <v-text-field
        v-model="phone"
        :rules="validatePhone"
        label="(555)555-5555"
        v-mask="['(', /\d/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
        solo
        validate-on-blur
      />

      <v-text-field
        v-model="extension"
        class="extension"
        label="(optional)"
        v-mask="'##########'"
        prefix="ext"
        hide-details
        single-line
        validate-on-blur
      />
    </v-form>

    <p class="subdued">
      We take your privacy seriously. We ask for your phone number to connect you quickly with a lender.
    </p>

    <button
      class="default-btn blue"
      @click="onContinue">
    <v-icon v-if="loading" class="mr-2">mdi-loading mdi-spin</v-icon>
    Continue
  </button>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { formMixin } from '@/mixins'

export default {
  name: 'QuestionnairePhoneStep',
  mixins: [formMixin],

  data: () => ({
    phone: '',
    extension: '',
    loading: false,
  }),

  computed: {
    ...mapGetters('feathers', ['apiTwilio']),
  },

  methods: {
    ...mapMutations('questionnaireStore', ['SET_NEW_PHONE']),

    async onContinue () {
      if (this.loading || !this.$refs.form.validate()) return
      this.loading = true

      try {
        const { phone, extension } = this
        const { valid } = await this.apiTwilio.get(phone)

        if (valid) {
          this.SET_NEW_PHONE({ phone, extension })
          this.$emit('finished')
        } else {
          this.addWarningAlert('Sorry, your phone number could not be verified. Please check the format or enter another phone number where you can be reached.')
        }
      } catch (error) {
        this.addErrorAlert('There was a problem confirming your phone number. Please try a different one or try again in a moment.')
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
h2 {
  margin-bottom: 30px;
}

p {
  margin: 20px 0 30px;
  text-align: center;
}

.v-form {
  max-width: 90%;

  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 0 10px;

  @include md {
    grid-template-columns: 1fr 140px;
    width: 500px;

    & > div:nth-child(1) {
      flex-grow: 1;
    }

    & > div:nth-child(2) {
      // width: 50px;
    }
  }
}

::v-deep {
  .v-text-field {
    .v-input__slot {
      border: 1px solid $inputBorderColor;
      box-shadow: none !important;
    }

    &.v-input--is-label-active {
      .v-input__slot {
        border-color: $inputBorderColorFilled;
      }
    }

    &.v-input--is-focused {
      .v-input__slot {
        border-color: $inputBorderColorFocused;
      }
    }

    &.error--text {
      .v-input__slot {
        border-color: $inputBorderColorError;
      }
    }

    &.extension {
      .v-input__control .v-input__slot {
        padding-left: 3px;
        border: none !important;
        box-shadow: none !important;

        &:after {
          border-style: none;
        }
      }
    }
  }
}
</style>
